import { TABLE_INITIAL_FILTERS } from 'components/@shared/TableFilters/constants';
import { AppointmentResponseViewModel } from 'types/appointment';
import { TableFiltersState, TableParams } from 'types/common';

export type AppointmentTableParams = TableParams & TableFiltersState;

export type State = {
    isLoading: boolean;
    list: AppointmentResponseViewModel[];
    tableParams: AppointmentTableParams;
    totalCount: number;
};

export const tableColumns = [
    {
        id: 'title',
        field: 'title',
        label: 'Name',
    },
    {
        id: 'status',
        field: 'status',
        label: 'Status',
    },
    {
        id: 'dateConfirmed',
        field: 'dateConfirmed',
        label: 'Preffered Date',
    },
    {
        id: '3',
        field: 'scheduledDateTime',
        label: 'Scheduled Date',
    },
    {
        id: '4',
        field: 'email',
        label: 'Email',
    },
    {
        id: '5',
        field: 'address',
        label: 'Address',
    },
    {
        id: '6',
        field: 'phoneNumber',
        label: 'Phone number',
    },
];

export const initialAppointmentsTableParams: TableParams = {
    sortOrder: 'asc',
    orderBy: tableColumns[0].field,
    page: 0,
    pageSize: 5,
    search: undefined,
};

export const initialState: State = {
    isLoading: true,
    list: [],
    tableParams: { ...initialAppointmentsTableParams, ...TABLE_INITIAL_FILTERS },
    totalCount: 0,
};

export const APPOINTMENT_DATE_CONFIRM_STATUS = 'Awaiting date confirmation' as const;
export const APPOINTMENT_CONTRACTOR_PROPOSAL_STATUS = 'Awaiting contractor proposal' as const;
export const APPOINTMENT_CLIENT_APPROVAL_STATUS = 'Awaiting client approval' as const;
export const APPOINTMENT_INVOICE_STATUS = 'Awaiting invoice' as const;
export const APPOINTMENT_SENT_STATUS = 'Invoice sent' as const;
export const APPOINTMENT_COMPLETE_STATUS = 'Complete' as const;
export const APPOINTMENT_CANCELED_STATUS = 'Canceled' as const;

export const APPOINTMENT_STATUSES = [
    APPOINTMENT_DATE_CONFIRM_STATUS,
    APPOINTMENT_CONTRACTOR_PROPOSAL_STATUS,
    APPOINTMENT_CLIENT_APPROVAL_STATUS,
    APPOINTMENT_INVOICE_STATUS,
    APPOINTMENT_SENT_STATUS,
    APPOINTMENT_COMPLETE_STATUS,
    APPOINTMENT_CANCELED_STATUS,
] as const;

export const APPOINTMENT_STATUS_OPTIONS = APPOINTMENT_STATUSES.map((status) => ({ id: status, name: status }));
